import request from './interceptor'

/**
 * 获取用户列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getUserList(params) {
  return request({
    url: '/v1/users',
    method: 'get',
    params
  })
}

/**
 * 获取用户详情
 * @param {Number} id 用户ID
 * @returns {Promise}
 */
export function getUserDetail(id) {
  return request({
    url: `/v1/users/${id}`,
    method: 'get'
  })
}

/**
 * 更新用户信息
 * @param {Number} id 用户ID
 * @param {Object} data 用户数据
 * @returns {Promise}
 */
export function updateUser(id, data) {
  return request({
    url: `/v1/users/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除用户
 * @param {Number} id 用户ID
 * @returns {Promise}
 */
export function deleteUser(id) {
  return request({
    url: `/v1/users/${id}`,
    method: 'delete'
  })
}

/**
 * 更新用户状态
 * @param {Object} data 请求数据，包含 user_id 和 status
 * @returns {Promise}
 */
export function updateUserStatus(data) {
  return request({
    url: '/v1/users/status',
    method: 'post',
    data
  })
}
